import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { CategoryTags } from './components/CategoryTags';
import { Location } from './components/Location';
import { Scope } from './components/Scope';

export const PetitionData: React.FC = () => {
	return (
		<div className="flex flex-col">
			<Text variant="heading" size="x-small" className="lowercase first-letter:uppercase" as="p">
				<Translate value="corgi.petition.edit.petition_data.heading" />
			</Text>
			<div className="flex flex-col gap-6">
				<Scope />
				<Location />
				<CategoryTags />
			</div>
		</div>
	);
};
